import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';


interface ActionAreaCardProps {
    title:string;
    image: string;       
    description: string; 
  }
  export default function ActionAreaCard({ title, image, description }: ActionAreaCardProps) {
    return (
      <Card sx={{ maxWidth: 345, width: '400px',height:"300px", marginBottom: '3%',borderRadius:"10px",backgroundColor:'rgba(51,194,239,0.2)'}}>
          <CardMedia
            component="img"
            height="100"
            width="10"
            image={image}
              
            sx={{
                margin:"0 auto",
                padding:"20px",
                height:"90px",
                width:"100px",
            }}
          />
          <CardContent>
          <Typography variant="body2" sx={{ color: 'text.secondary',textAlign:"center", fontSize: { xs: '1.5rem', md: '1.3rem' },fontWeight:"bold",marginBottom:"15px" }}>
              {title} 
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary',textAlign:"center" }}>
              {description} 
            </Typography>
          </CardContent>
          
      </Card>
    );
  }
